import {createContext} from "react";

export const ClassListContext = createContext('classlist')
export const DocContext = createContext('callback')
